import { useShoppingCartController } from 'client/controllers/cartController'
import { ShoppingCart as CartIcon, Cross } from '@blueprintjs/icons'
import { FC } from 'react'
import { Button } from '../Button/Button'
import { useTranslation } from 'react-i18next'
import { ClientLocaleNS } from 'lib/constants/locales'
import { Drawer, Text } from '@blueprintjs/core'
import { ProductItem } from './components/ProductItem/ProductItem'
import { router } from '@inertiajs/react'

type TProps = {}

const CartDrawer: FC<TProps> = () => {
  const { t } = useTranslation(ClientLocaleNS.Common)
  const { orderables, isOpen, setIsOpen } = useShoppingCartController()
  const orderablesLength = orderables.length
  return (
    <>
      {!!orderablesLength && (
        <div className="fixed bottom-10 right-10">
          <Button
            icon={<CartIcon className="text-palette-white" />}
            onClick={(e) => {
              setIsOpen(true)
            }}
          >
            {`${t('cart.button')} (${orderables.reduce((acc, item) => item.quantity + acc, 0)})`}
          </Button>
        </div>
      )}
      <Drawer
        className="flex flex-col h-full bg-palette-grey"
        backdropClassName="max-h-full"
        size="40rem"
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
      >
        <div className="flex w-full flex-col h-full gap-4">
          <div className="flex w-full items-center justify-between border-b border-solid border-palette-grey p-4 flex-none text-palette-black">
            <div className="flex items-center gap-4">
              <CartIcon className="" />
              <Text tagName="span" className="font-body---20px">
                {t('cart.title')}
              </Text>
            </div>
            <Cross className="cursor-pointer p-1" onClick={() => setIsOpen(false)} />
          </div>
          <div className="flex flex-1 overflow-auto flex-col px-4 gap-4">
            <div className="grid grid-cols-12 w-full 4 gap-x-3">
              <Text tagName="span" className="col-span-2 font-body---20px">
                {t('cart.product')}
              </Text>
              <div className="col-span-7"></div>
              <Text tagName="span" className="col-span-3 font-body---20px text-right">
                {t('cart.total')}
              </Text>
            </div>
            <ul className="flex flex-col w-full gap-4 flex-none">
              {orderables.map((item) => {
                return <ProductItem key={item.product.id} data={item} />
              })}
            </ul>
          </div>
          <div className="flex w-full justify-center flex-none p-4 pt-0">
            <Button
              onClick={() => {
                setIsOpen(false)
                router.get('/checkout')
              }}
            >
              {t('cart.checkout')}
            </Button>
          </div>
        </div>
      </Drawer>
    </>
  )
}

export { CartDrawer }
